<script setup lang="ts">
defineProps<{
  product: SingleProduct;
}>();
</script>

<template>
  <UContainer
    class="pt-8 pb-24 lg:grid lg:items-center lg:gap-16 lg:pt-20 lg:pb-36"
    :class="product.cover?.url ? 'grid-cols-2' : 'grid-cols-1'"
  >
    <div class="flex flex-col gap-8">
      <h1
        class="text-center font-headline text-4xl lg:text-start"
        v-text="product.title"
      />
      <div
        class="text-center text-base lg:text-start lg:text-2xl"
        v-html="product.intro"
      />
      <CrystallizeImage
        :image="product.cover"
        img-class="-my-6 mx-auto max-w-[50%] lg:hidden"
      />
      <div
        class="max-w-2xl self-center text-base lg:text-xl [&_ul]:flex [&_ul]:list-inside [&_ul]:list-disc [&_ul]:flex-col [&_ul]:gap-1 lg:[&_ul]:list-outside lg:[&_ul]:gap-3"
        v-html="product.description"
      />
    </div>
    <CrystallizeImage
      :image="product.cover"
      img-class="hidden max-w-full object-cover lg:block"
    />
  </UContainer>
</template>
